import React from 'react';

export const BRAIN_ICON = (
  <svg width="65" height="73" fill="none">
    <path
      d="M24.853 11.47c-3.651 0-6.609 2.652-7.349 6.095-4.458.795-7.945 4.516-7.945 9.2 0 .47.052.888.12 1.315-1.232 1.812-2.032 3.948-2.032 6.331 0 3.436 1.711 6.326 4.122 8.424-.172.68-.298 1.359-.298 2.091 0 4.728 3.875 8.603 8.603 8.603h.12c1.113 2.158 3.04 3.824 5.615 3.824a6.67 6.67 0 004.78-2.032 6.673 6.673 0 004.779 2.032c2.577 0 4.502-1.666 5.617-3.824h.118c4.49 0 8.17-3.495 8.544-7.886h.06c0-.12-.052-.239-.06-.36.008-.118.06-.238.06-.357 0-.709-.255-1.315-.42-1.97 2.48-2.108 4.243-5.048 4.243-8.545 0-2.382-.8-4.517-2.032-6.333.068-.425.12-.841.12-1.313 0-4.684-3.487-8.403-7.945-9.202-.74-3.44-3.698-6.093-7.35-6.093-2.293 0-4.331 1.069-5.734 2.688-1.404-1.617-3.441-2.688-5.736-2.688zm0 3.824a3.794 3.794 0 013.824 3.823v3.824a5.708 5.708 0 01-5.735 5.735V32.5c2.166 0 4.129-.746 5.735-1.971V50.66a2.84 2.84 0 01-2.868 2.868 2.81 2.81 0 01-2.808-2.33l-.358-1.85-1.852.297a4.755 4.755 0 01-5.497-4.72c0-.59.096-1.143.299-1.673.015-.044.046-.076.059-.12a4.72 4.72 0 013.466-2.868l-.776-3.762a8.51 8.51 0 00-4.96 2.986 7.567 7.567 0 01-1.911-5.078 7.455 7.455 0 011.673-4.72l.598-.716-.18-.956a5.457 5.457 0 01-.18-1.254 5.708 5.708 0 015.736-5.736h1.912v-1.912a3.794 3.794 0 013.823-3.823z"
      fill="#000"
    />
    <path fill="#fff" d="M30.588 0H65v72.647H30.588z" />
    <path
      d="M31.797 0v17.67c1.659.086 3.295.46 4.821 1.11a6.476 6.476 0 002.613-.525 6.431 6.431 0 002.174-1.53 2.912 2.912 0 01-.424-2.468c.118-.417.328-.803.614-1.13a2.947 2.947 0 012.31-1.004 2.967 2.967 0 012.249 1.136c.266.342.453.74.546 1.162l.012.018a2.908 2.908 0 01-.88 2.78 2.978 2.978 0 01-2.863.652 7.882 7.882 0 01-3.75 2.438 12.613 12.613 0 012.576 2.66 3.027 3.027 0 012.246.36c2.22 1.393 1.642 4.751-.92 5.325-2.56.573-4.549-2.209-3.15-4.414.058-.086.122-.172.188-.258a10.384 10.384 0 00-4.15-3.343 12.05 12.05 0 00-4.212-1.059v11.5c2.471.172 3.63 1.413 4.494 2.391.657.734 1.03 1.119 1.671 1.153.934.052 1.642.023 2.33 0 .863-.05 1.728-.028 2.587.063 2.717-.049 3.677-.648 4.64-1.279a7.353 7.353 0 013.269-1.328 2.933 2.933 0 01.65-1.147c.066-.071.136-.126.202-.189a13.588 13.588 0 010-6.897l-.034-.028a2.907 2.907 0 01-.492-3.701 2.945 2.945 0 011.576-1.223 2.97 2.97 0 011.999.056c.64.25 1.17.713 1.503 1.31a2.905 2.905 0 01-.703 3.667 2.963 2.963 0 01-1.883.67h-.165c-.4 1.773-.4 3.611 0 5.383h.182a2.966 2.966 0 012.355 1.17 2.913 2.913 0 01.474 2.568 2.92 2.92 0 01-.664 1.17 2.97 2.97 0 01-3.74.493l-.136-.096a2.872 2.872 0 01-1.017-1.267 5.471 5.471 0 00-2.353 1.015 8.778 8.778 0 01-2.032 1.047c2.188 1.591 5.122 4.588 6.356 6.592a2.968 2.968 0 013.104 1.07 2.912 2.912 0 01.478 2.575 2.918 2.918 0 01-.667 1.172 2.97 2.97 0 01-3.75.48l-.136-.086a2.914 2.914 0 01-1.186-1.818 2.897 2.897 0 01.553-2.334c-1.287-2.223-5.857-6.539-7.111-6.846a11.762 11.762 0 00-3.787-.335c-.694.023-1.483.052-2.503 0-1.489-.077-2.263-.955-3.015-1.804-.752-.849-1.474-1.606-3.05-1.752v20.056c.425-.08.838-.21 1.232-.387a.972.972 0 01.168-.077c1.618-.766 4.107-2.61 6.058-7.017a2.922 2.922 0 01-1.14-1.778 2.936 2.936 0 011.436-3.125 2.967 2.967 0 013.994 1.048 2.907 2.907 0 01-.982 3.98 2.964 2.964 0 01-1.443.437 17.98 17.98 0 01-4.14 6.125 5.182 5.182 0 011.998.878c.297.267.67.435 1.07.481a9.629 9.629 0 002.566-.636 2.905 2.905 0 01.36-1.804 2.94 2.94 0 011.373-1.235 2.97 2.97 0 013.433.773V50.7a2.905 2.905 0 01.439 3.122 2.932 2.932 0 01-1.086 1.24 2.966 2.966 0 01-1.588.464 2.967 2.967 0 01-2.078-.823 11.448 11.448 0 01-3.376.823h-.145a3.813 3.813 0 01-2.052-.788c-.758-.508-1.474-.99-4.053-.344a6.102 6.102 0 01-2.044.573v13.856L61.177 52.1V16.724L31.796 0zm12.007 14.063a1.023 1.023 0 00-.953.712 1.002 1.002 0 00.384 1.12l.052.029a1.037 1.037 0 001.399-.31v-.005a1.003 1.003 0 00-.355-1.412 1.026 1.026 0 00-.521-.134h-.006zm9.814 6.618a1.023 1.023 0 00-.853.474v.005a.997.997 0 00.277 1.357l.038.028a1.039 1.039 0 001.408-.31 1.003 1.003 0 00-.348-1.414 1.026 1.026 0 00-.522-.14zM42.41 24.797a1.024 1.024 0 00-.8.467 1.011 1.011 0 00.343 1.402c.155.092.331.143.512.146 1.393 0 1.34-2.093-.055-2.015zM53.618 31.9a1.025 1.025 0 00-.853.47.997.997 0 00.272 1.362l.043.029a1.04 1.04 0 001.402-.316 1.004 1.004 0 00-.349-1.407 1.014 1.014 0 00-.515-.138zM40.97 42.206a1.024 1.024 0 00-.975.862.997.997 0 00.302.876 1.021 1.021 0 001.718-.644 1.003 1.003 0 00-.5-.956 1.024 1.024 0 00-.548-.138h.003zm12.647 2.263a1.025 1.025 0 00-.853.47v.006a1.002 1.002 0 00.272 1.356l.043.029a1.04 1.04 0 001.402-.31 1.004 1.004 0 00-.347-1.41 1.023 1.023 0 00-.52-.139l.003-.002zm-8.103 7.14a1.008 1.008 0 00-.644.24 1.01 1.01 0 00-.295 1.12 1.01 1.01 0 00.96.659 1.008 1.008 0 00.406-1.935 1.027 1.027 0 00-.407-.087c-.006 0-.013.003-.02.003z"
      fill="#000"
    />
  </svg>
);

export const TOOL_ICON = (
  <svg width="66" height="66" fill="none">
    <path
      d="M65.136 53.945l-27.26-27.424c2.696-6.932 1.199-15.069-4.493-20.795C27.393-.3 18.406-1.506 11.216 1.81l12.881 12.958-8.987 9.041L1.93 10.85c-3.594 7.232-2.097 16.274 3.894 22.3 5.692 5.727 13.78 7.234 20.67 4.521l27.259 27.425c1.198 1.205 2.995 1.205 4.193 0l6.89-6.932c1.498-1.205 1.498-3.315.3-4.219z"
      fill="#000"
    />
  </svg>
);

export const DELETE_ICON = (
  <svg width="12" height="14" fill="none">
    <path
      d="M0.666992 3.66667H11.3337M10.667 3.66667L10.089 11.7613C10.065 12.0977 9.91452 12.4125 9.66774 12.6424C9.42095 12.8722 9.09623 13 8.75899 13H3.24166C2.90442 13 2.5797 12.8722 2.33292 12.6424C2.08613 12.4125 1.9356 12.0977 1.91166 11.7613L1.33366 3.66667H10.667ZM4.66699 6.33333V10.3333V6.33333ZM7.33366 6.33333V10.3333V6.33333ZM8.00033 3.66667V1.66667C8.00033 1.48986 7.93009 1.32029 7.80506 1.19526C7.68004 1.07024 7.51047 1 7.33366 1H4.66699C4.49018 1 4.32061 1.07024 4.19559 1.19526C4.07056 1.32029 4.00033 1.48986 4.00033 1.66667V3.66667H8.00033Z"
      stroke="#EB5757"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WARNING_UNSAVED_ICON = (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.99995 5.00032V6.33366V5.00032ZM6.99995 9.00032H7.00662H6.99995ZM2.38128 11.667H11.6186C12.6453 11.667 13.2866 10.5557 12.7733 9.66699L8.15462 1.66699C7.64128 0.778322 6.35862 0.778322 5.84528 1.66699L1.22662 9.66699C0.713283 10.5557 1.35462 11.667 2.38128 11.667Z"
      fill="#FBF2DC"
      stroke="#4F4F4F"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PLUS_ICON = (
  <svg
    className="h-4 w-4 text-litlingo-primary-120"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 4v16m8-8H4" />
  </svg>
);

export const ERROR_ICON = (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 4.33333V7V4.33333ZM7 9.66667H7.00667H7ZM13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
      stroke="#EB5757"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PLUS_ADD_FIELD_ICON = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.99951V16.9995"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 9.99951H3"
      stroke="#333333"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ACTIVE_ICON = (
  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.5" cy="3.5" r="3.5" fill="#219653" />
  </svg>
);

export const INACTIVE_ICON = (
  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.5" cy="3.5" r="3.5" fill="#BDBDBD" />
  </svg>
);

export const TEST_ICON = (
  <svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="3.5" cy="3.5" r="3.5" fill="#F2994A" />
  </svg>
);
